export const TableEvent = {
  RELOAD: 'TableEvent:RELOAD',
  RELOAD_AND_PERSIST_PAGE: 'TableEvent:RELOAD_AND_PERSIST_PAGE',
  RELOAD_AND_SELECT: 'TableEvent:RELOAD_AND_SELECT',
  SET_LOADING: 'TableEvent:SET_LOADING',
  ADD_ROW: 'TableEvent:ADD_ROW',
  UPDATE_ROW: 'TableEvent:UPDATE_ROW',
  DELETE_START_ROW: 'TableEvent:DELETE_START_ROW',
  DELETE_ROW: 'TableEvent:DELETE_ROW',
  RESTORE_FAILED_ROW: 'TableEvent:RESTORE_FAILED_ROW',
  LOAD_DATA_TABLE_ID: 'TableEvent:LOAD_DATA:{table_id}',
  LOADING_STATE_CHANGED: 'TableEvent:LOADING_STATE_CHANGED:{table_id}',
  NEW_ROW_DATA_TABLE_ID: 'TableEvent:NEW_ROW_DATA_TABLE_ID:{table_id}:{entity_id}',
  LOAD_DATA: 'TableEvent:LOAD_DATA:',
  REMOVE_SELECTED_ROW: 'TableEvent:REMOVE_SELECTED_ROW',
  REMOVE_SIBLING_SELECTED_ROWS: 'TableEvent:REMOVE_SIBLING_SELECTED_ROWS',
  SELECT_ROW: 'TableEvent:SELECT_ROW',
  START_IS_LOADING_ROW: 'TableEvent:START_IS_LOADING_ROW:',
  STOP_IS_LOADING_ROW: 'TableEvent:STOP_IS_LOADING_ROW:',
  SEARCH: 'TableEvent:SEARCH',
  TOGGLE_DETAILS: 'TableEvent:TOGGLE_DETAILS',
  HIDE_DETAILS: 'TableEvent:HIDE_DETAILS',
  SCROLL: 'TableEvent:SCROLL',
  PREVIOUS_PAGE: 'TableEvent:PREVIOUS_PAGE',
  NEXT_PAGE: 'TableEvent:NEXT_PAGE',
  ADD_CREATION_ROW: 'TableEvent:ADD_CREATION_ROW',
  DELETE_CREATION_ROW: 'TableEvent:DELETE_CREATION_ROW',
  ON_HIGHLIGHT_ROWS_REQUESTED: 'TableEvent:ON_HIGHLIGHT_ROWS_REQUESTED',
  /**
   * @param {string} tableId
   * @param {number|string} rowId
   * @returns {string}
   */
  formatNewRowDataTableId(tableId, rowId) {
    return TableEvent.NEW_ROW_DATA_TABLE_ID.replace('{table_id}', tableId).replace(
      '{entity_id}',
      rowId
    );
  }
};
